import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../../_redux/section-renewal/SectionRenewalAction";
import { getAuthorities, resultAlert } from "../../../../../../_helpers/Helpers";
import { 
  Card, 
  CardBody, 
  CardHeader,
  CardHeaderToolbar,
  ModalProgressBar
} from "../../../../../../_metronic/_partials/controls";
import { useStudentsUIContext } from "./StudentsUIContext";
import { StudentsFilter } from "./students-filter/StudentsFilter";
import { StudentsTable } from "./students-table/StudentsTable";

export function StudentsCard() {
  // Students UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      newTerm: studentsUIContext.newTerm,
      currentTerm: studentsUIContext.currentTerm,
      newSectionId: studentsUIContext.newSectionId,
      sectionValues: studentsUIContext.sectionValues,
      setSectionValues: studentsUIContext.setSectionValues
    };
  }, [studentsUIContext]);

  // Getting curret state of Students from store (Redux)
  const { currentState } = useSelector(
    (state) => ({ currentState: state.sectionRenewal }),
    shallowEqual
  );  
  const { actionsLoading, authorities, studentSections } = currentState;

  // Authority Parameters
  const { isEditionAuthorized } = getAuthorities(authorities);

  // Students Redux state
  const dispatch = useDispatch();

  useEffect(() => {
    studentsUIProps.setSectionValues(studentSections);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentSections]);

  useEffect(() => {
    if (studentsUIProps.newSectionId) {
      const newSectionValues = [];
      studentsUIProps.sectionValues.forEach(value => newSectionValues.push({ id: value.id, sectionId: studentsUIProps.newSectionId }));
      studentsUIProps.setSectionValues(newSectionValues);      
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentsUIProps.newSectionId]);

  /** Öğrencilerin Yeni Dönem İçin Seçilen Şubelerini Kaydeder */
  const saveSections = (sectionValues) => {
    const datas = [];
    sectionValues.forEach(value => datas.push({
      id: value.id,
      sectionId: value.sectionId,
      newTerm: studentsUIProps.newTerm
    }));
    dispatch(actions.saveSections(studentsUIProps.currentTerm, datas)).then(({ type, message }) => resultAlert(type, message));
  }

  return (
    <Card>
      {actionsLoading && <ModalProgressBar />}
      <CardHeader title="Öğrenci Listesi">
        {
          isEditionAuthorized &&
          <CardHeaderToolbar>
            <button
              type="button"
              className="btn btn-primary ml-2"
              onClick={() => saveSections(studentsUIProps.sectionValues)}
            >
              Kaydet
            </button>
          </CardHeaderToolbar>
        }
      </CardHeader>
      <CardBody>
        <StudentsFilter />
        <StudentsTable />
      </CardBody>
    </Card>
  );
}